import React from 'react'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import PrimaryButton from 'components/common/buttons/PrimaryButton'
import Send from 'components/common/icons/Send'

const useStyles = makeStyles(() => ({
  tooltip: {
    width: '450px',
    minHeight: '140px',
    userSelect: 'none',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: 20,
    backgroundColor: 'white',
    zIndex: 2,
    borderRadius: 15,
    border: '1px solid var(--bg-color-65)',
    boxShadow: '1px 4px 8px rgba(0, 19, 53, 0.1)'
  }
}))

const SendInvitationTooltip = ({ isOpen, onSendClicked, wasPatientInvited }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return isOpen ? (
    <div className={classes.tooltip}>
      {!wasPatientInvited ? (
        <>
          <DazzedParagraph14 style={{ marginBottom: 10 }}>
            {t('pages.patients.patientSidebar.items.liveCalls.sendInvitationTooltip')}
          </DazzedParagraph14>
          <PrimaryButton
            disabled={!isOpen}
            disableIconMargin
            icon={<Send style={{ marginRight: 5 }} />}
            height={35}
            label={t('general.send')}
            onClick={onSendClicked}
          />
        </>
      ) : (
        <DazzedParagraph14 style={{ marginBottom: 10 }}>
          {t('pages.patients.patientSidebar.items.liveCalls.waitingForPatientToJoin')}
        </DazzedParagraph14>
      )}
    </div>
  ) : (
    <></>
  )
}

export default SendInvitationTooltip
